module.exports = __webpack_public_path__ + "media/ye-also.92350615.mp3";